import React, { useEffect, useState } from "react";
import "./AdaptorSinglePage.css";
import ff from "../../images/adaptor-full-image.svg";
import ht from "../../images/heart.svg";
import gn from "../../images/green-tick.svg";
import gg from "../../images/gift-green.svg";
import gd from "../../images/green-dark-tick.svg";
import eye from "../../images/eye-thin.svg";
import AdaptorTab from "../AdaptorTab/AdaptorTab";
import ang from "../../images/right-angle.svg";
import { useParams } from "react-router-dom";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import dd from "../../images/download-white.svg";
import fd from "../../images/pp-logo.gif";
import buttonloader from "../../images/buttonloader.gif";

function AdaptorSinglePage({ token, onsignup }) {

  const { slug } = useParams();

  const [loading, setLoading] = useState(true);

  const [loadingPay, setloadingPay] = useState(false);

  const [ebook, setEbook] = useState(null);

  const [activePreview, setActivePreview] = useState(null);


  const [backgroundPosition, setBackgroundPosition] = useState('0% 0%');
  const [isHovered, setIsHovered] = useState(false);

  const HandlePament = async (ebook) => {

    try {

      setloadingPay(true);

      const response = await fetch(`${END_URL}/ebook-store-payment`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ebook_id: ebook
        }),
      });

      const data = await response.json();

      if (data.payment) {

        window.location.href = data.payment;
      } else {

        setloadingPay(false);

      }

    } catch (error) {

      console.error("Error sending result:", error);
      setloadingPay(false);
    }
  };


  const LoginShow = () => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    onsignup(true);
  };

  useEffect(() => {

    fetchEbook();

  }, [slug]);

  const fetchEbook = async () => {

    try {

      setLoading(true);

      const response = await axios.get(

        `${END_URL}/ebook-store/${slug}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {

        setEbook(response.data.data);
      }

    } catch (error) {

      console.log(error);

    } finally {

      setLoading(false);
    }
  };

  const handleRedirect = (link) => {

    if (!link) return;

    window.location.href = `/${link}`;

  };


  if (loading) {

    return (
      <div className="loadingDiv" >

        <img src={fd} alt="Loading..." />

      </div>
    );
  }



  const currentImgSrc = activePreview === ebook?.id
    ? `${IMG_URL}/d0/${ebook?.preview_short_summary_image}`
    : `${IMG_URL}/d0/${ebook?.book_cover}`;

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.currentTarget.getBoundingClientRect();
    // Calculate cursor position percentage inside the image container
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  };


  return (
    <div className="adapter-single-cont">
      <div className="container">
        <div className="row">
          <div className="adapter-single-links">
            <ul>
              <li>
                <a href="/">
                  {" "}
                  Home{" "}
                  <span>
                    <img src={ang} alt="" />
                  </span>
                </a>
              </li>
              <li>
                <a href="/ebook-store">
                  Bookstore
                  <span>
                    <img src={ang} alt="" />
                  </span>
                </a>
              </li>

              <li>
                <a href="">
                  {ebook?.title}
                  <span>
                    <img src={ang} alt="" />
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="row adapter-single-outer">
          <div className="col-md-4">

            <div className="adapter-single-imageDiv adapter-single-box"

            // onMouseEnter={() => setIsHovered(true)}
            //   onMouseLeave={() => setIsHovered(false)}
            //   onMouseMove={handleMouseMove}
            //   style={{
            //     backgroundImage: isHovered ? `url("${currentImgSrc}")` : 'none',
            //     backgroundPosition: backgroundPosition,
            //     backgroundSize: '250%', /* Adjust scale factor as needed */
            //     backgroundRepeat: 'no-repeat',
            //   }}

            >

              <div
                className="image-zoom-container"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onMouseMove={handleMouseMove}
                style={{
                  backgroundImage: isHovered ? `url("${currentImgSrc}")` : 'none',
                  backgroundPosition: backgroundPosition,
                  backgroundSize: '200%',
                  backgroundRepeat: 'no-repeat',
                }}
              >

              <img
                src={currentImgSrc}
                alt={ebook?.title || "Ebook Cover"}
                style={{
                  opacity: isHovered ? 0 : 1, /* Hide foreground image on hover to reveal background zoom */
                  transition: 'opacity 0.2s ease',
                  width: '100%',
                  height: 'auto',
                  display: 'block'
                }}
              />
            </div>

            {ebook?.preview_short_summary && ebook?.preview_short_summary_image && (
              <>
                <a
                  className="adapter-image-prev"
                  onClick={() =>
                    setActivePreview(
                      activePreview === ebook?.id ? null : ebook?.id
                    )
                  }
                >
                  <img src={eye} alt="" />
                  {activePreview === ebook?.id ? "Hide Preview" : "Preview Inside"}
                </a>

                {activePreview === ebook?.id && (
                  <div className="preview-content show-preview">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: ebook?.preview_short_summary,
                      }}
                    />
                  </div>
                )}
              </>
            )}

          </div>
        </div>

        <div className="col-md-8">
          <div className="adapter-single-content">
            <div className="adpter-single-tops">
              <div
                style={{
                  "--bg-color-top": "#E4D7EE",
                  "--text-color-top": "#88619A",
                }}
              >
                <span></span>{ebook?.book_detail?.arche_type_guide}
              </div>
              <div
                style={{
                  "--bg-color-top": "#E6F4F5",
                  "--text-color-top": "#43796E",
                }}
              >
                {ebook?.icon_image && (
                  <span>
                    <img src={`${IMG_URL}/d0/${ebook?.icon_image}`} alt="" />
                  </span>
                )}

                {ebook?.category}
              </div>
            </div>

            <div className="adapter-single-review">
              <h4>{ebook?.title}</h4>
              <div>

                <span> {"★".repeat(Math.round(ebook?.rating || 0))} </span>
                <p>
                  {ebook?.rating} {ebook?.rating_count && (<span>({ebook?.rating_count})</span>)}
                </p>
              </div>
            </div>

            <div className="adapter-single-textDiv">

              <h6>${ebook?.price}</h6>

              <div dangerouslySetInnerHTML={{ __html: ebook?.description }} />

            </div>

            <div className="adapter-single-account">

              <div className="adapter-single-amount">

                <h5>{ebook?.book_detail?.payment_book_label}</h5>

                <h6>${ebook?.price}</h6>

              </div>

              <div className="adapter-single-btns">

                {!ebook?.is_paid ? (


                  token ? (

                    <button onClick={() => !loadingPay && HandlePament(ebook?.id)} className="buy-adapter-btn" style={{ pointerEvents: loadingPay ? "none" : "auto" }} >

                      {ebook?.book_detail?.ebook_buy_now_button_label} {loadingPay && (<img width={50} src={buttonloader} alt="Loading" />)}

                    </button>

                  ) : (

                    <button onClick={() => LoginShow(ebook?.id)} style={{ pointerEvents: loadingPay ? "none" : "auto" }} >

                      {ebook?.book_detail?.ebook_buy_now_button_label}

                    </button>
                  )

                ) : (

                  <button className="ebook-download"
                    onClick={() => {
                      if (!ebook?.ebook_file) return;

                      const link = document.createElement('a');
                      link.href = `${IMG_URL}/d0/${ebook.ebook_file}/download`;
                      link.download = '';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <img src={dd} alt="" /> <span>Download</span>

                  </button>
                )}

                <a onClick={() => handleRedirect(ebook?.book_detail?.ebook_take_quiz_link)} >{ebook?.book_detail?.ebook_take_quiz_label}</a>

              </div>

              <div className="adapter-single-acout-dec">

                <img src={gd} alt="" />

                <div dangerouslySetInnerHTML={{ __html: ebook?.book_detail?.ebook_pay_content }} />

              </div>
              {/* {ebook?.is_paid && (

                  <div className="ebooklist-allbtn" >

                    <button className="ebook-download"
                        onClick={() => {
                            if (!ebook?.ebook_file) return;

                            const link = document.createElement('a');
                            link.href = `${IMG_URL}/d0/${ebook.ebook_file}/download`;
                            link.download = '';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }}
                    >

                      <img src={dd} alt="" /> <span>Download</span>

                    </button>

                  </div>
                )} */}

            </div>

          </div>

        </div>
      </div>

      <div className="row adapter-tab-call">

        <AdaptorTab ebook={ebook} />

      </div>
    </div>
    </div >
  );
}

export default AdaptorSinglePage;
